import React from 'react';

const HeaderSection = ({ title = "Why African Languages Matter", subtitle = "Supporting African languages is essential for preserving culture, fostering inclusion, and unlocking new opportunities.", header = "THE NEED FOR NKENNEAi" }) => {
  return (
    <div className="flex flex-col items-center gap-8 w-full max-w-[1071px] mx-auto px-4">
      <h3 className="text-[#ef8702] font-black text-base">
        {header}
      </h3>
      <div className="flex flex-col items-center gap-4">
        <h1 className="text-black font-black text-[45px] text-center">
          {title}
        </h1>
        <p className="text-black text-base font-normal text-center">
          {subtitle}
        </p>
      </div>
    </div>
  );
};

export default HeaderSection;
